export default __webpack_public_path__ + "static/media/behind-the-waves.b653cb4d.jpg";